import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { ContactService, Category, Contact } from '@fgb/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'fgb-contact-us-page',
  templateUrl: './contact-us-page.component.html',
  styleUrls: ['./contact-us-page.component.scss'],
})
export class ContactUsPageComponent implements OnInit, OnDestroy {
  contactUsForm: FormGroup;
  categories$: Observable<Category[]>;
  submitted = false;
  sentSuccessfully: boolean = false;

  firstCatSub: Subscription;

  constructor(private formBuilder: FormBuilder, private contactService: ContactService) {}

  get f() {
    return this.contactUsForm.controls;
  }

  ngOnInit() {
    this.categories$ = this.contactService.getCategories();

    this.contactUsForm = this.formBuilder.group({
      category: [''],
      message: ['', Validators.required],
    });

    this.firstCatSub = this.categories$.pipe(take(1)).subscribe(cats => {
      if (cats.length > 0) {
        this.contactUsForm.controls.category.setValue(cats[0].Name);
      }
    });
  }

  ngOnDestroy() {
    this.firstCatSub.unsubscribe();
  }

  async submit(message: Contact, isValid: boolean) {
    this.submitted = true;
    if (isValid) {
      await this.contactService.sendMessage(message);
      this.sentSuccessfully = true;
    }
  }
}
